import { useMemo } from 'react';
import groupBy from 'lodash/groupBy';
import { TabLeaf, TabRoot } from '../useTabGroupTree';
import FooterButton from '../footerButtons/FooterButton';
import { JSONSchemaObject } from '../../../../util/jsonschemaTypes';
import { FooterButtonDef, FooterButtonJsonSchema } from '../footerButtons/types';
import { Bindings, Data, FunctionBindings } from '../../../../util/jnx';

function useFooterButtons({
  uiFooterButtons,
  schema,
  canBeAsTabPanel,
  asGroupedTabs,
  tabRoot,
  selectedTab,
  setSelectedTab,
  rootFormData,
  path,
  bindings,
  functionBinds,
}: {
  uiFooterButtons: FooterButtonDef[];
  schema: JSONSchemaObject;
  canBeAsTabPanel?: boolean;
  asGroupedTabs?: boolean;
  tabRoot: TabRoot;
  selectedTab: TabLeaf | null;
  setSelectedTab: (tab: TabLeaf | null) => void;
  rootFormData?: Data;
  path?: string;
  bindings?: Bindings;
  functionBinds?: FunctionBindings;
}) {
  const hasFooterBtns = useMemo(() => uiFooterButtons && uiFooterButtons.length > 0, [uiFooterButtons]);

  const footerBtns = useMemo(() => {
    if (!hasFooterBtns) return null;
    const byPosition = groupBy(uiFooterButtons, btn => btn.align || 'right');
    const btnProps = {
      canBeAsTabPanel,
      asGroupedTabs,
      tabRoot,
      selectedTab,
      setSelectedTab,
      schema: schema as FooterButtonJsonSchema,
      path,
      rootFormData,
      bindings,
      functionBinds,
    };
    return (
      <>
        {byPosition.left && byPosition.left.length > 0 && (
          <div className="object-field-template-footer-section">
            {byPosition.left.map((btn, ix) => (
              <FooterButton key={ix} btnDef={btn} {...btnProps} />
            ))}
          </div>
        )}
        {byPosition.center && byPosition.center.length > 0 && (
          <div className="object-field-template-footer-section">
            {byPosition.center.map((btn, ix) => (
              <FooterButton key={ix} btnDef={btn} {...btnProps} />
            ))}
          </div>
        )}
        {byPosition.right && byPosition.right.length > 0 && (
          <div className="object-field-template-footer-section">
            {byPosition.right.map((btn, ix) => (
              <FooterButton key={ix} btnDef={btn} {...btnProps} />
            ))}
          </div>
        )}
      </>
    );
  }, [hasFooterBtns, uiFooterButtons, schema, setSelectedTab, asGroupedTabs, selectedTab, tabRoot, rootFormData, bindings]);

  return {
    hasFooterBtns,
    footerBtns,
  };
}

export default useFooterButtons;
